export const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w{2,}$/;
export const PHONE_REGEX = /^0[\d]{9}$/;
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9!@#$%^&*(){}_+: "'<>?|,.;=]{8,128})$/;
export const USERNAME_REGEX = /^(?:[A-Z\d][A-Z\d_-]{0,39}|\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w{2,})$/i;
export const INTEGER_REGEX = /^-?\d+$/;
export const IPV4_REGEX =
  /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$/;
export const DATE_REGEX = /^\d{4}-\d{1,2}-\d{1,2}$/;
export const MONTH_REGEX = /^\d{4}-\d{1,2}$/;
export const YEAR_REGEX = /^\d{4}$/;
export type ISO8601Date = `${number}-${number}-${number}`;
export type ISO8601Time = `${number}:${number}:${number}${string}`;
export type ISO8601Timestamp = `${ISO8601Date}T${ISO8601Time}Z`;

export interface IParamValidation {
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  pattern?: string | RegExp;
  customValidation?: (...args: any) => boolean;
  min?: number;
  max?: number;
  email?: boolean;
  username?: boolean;
  url?: string;
  integer?: boolean;
  errorMsg?: string;
  customRequired?: (...args: any) => boolean;
}

export default IParamValidation;
